import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../seo.service';
import {AppComponent} from '../app.component';

@Component({
  selector: 'app-software',
  templateUrl: './software.component.html',
  styleUrls: ['./software.component.scss']
})
export class SoftwareComponent implements OnInit {

  public mode_html:boolean = true;
  private modeHtmlObservable:any;

  constructor(private appfuncion:AppComponent, private title:Title, private seo:SeoService) { }

  ngOnInit(): void {
    let t:string = 'Nuestros prodcutos';
    this.title.setTitle(t);

    this.seo.generateTags({
      title: 'Nuestros prodcutos',
      description: 'Nuestros prodcutos',
      image: '../assets/img/software/asesorias.svg',
      slug: 'nuestros-prodcutos',
      keywords: 'prodcutos qualitysoft group, desarrollo de software, asesorias, diseño web, soporte tecnico, santa marta, rpa, ti'
    });

    this.mode_html = this.appfuncion.mode_html;
    this.modeHtmlObservable = this.appfuncion.getmode_html$().subscribe((mode_html:boolean)=>{
        this.mode_html = mode_html;
    });
  }

  ngOnDestroy() {
    if(this.modeHtmlObservable) this.modeHtmlObservable.unsubscribe();
  }

}
